<template>
  <div id="user-profile" class="pointer-events-none" data-id="userId">

    <!-- Collapsed content -->
    <div class="
      absolute pin-l pin-r md:pin-t z-30
      md:overflow-auto
      pointer-events-auto 
      w-full md:w-2/5 md:max-w-sm
      md:m-4
      md:rounded shadow bg-white
      text-white
    ">
      <div @click="closeButtonClicked" class="cursor-pointer absolute pin-t pin-r py-2 px-2"><img src="../assets/img/close-white.svg" class="w-6" />
      </div>
      <div class="clearfix bg-brand">
        <!-- Header, shown on both mobile and desktop -->
        <div class="p-4">
          <div style="min-height: 200px;">
            <img :src="profile.imageUrl" class="block rounded z-10"/>
          </div>
          <csf-button @click="$emit('showRandom')" type="primary" class="text-sm mt-4">Show another learner</csf-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import firebase from "firebase";
import CsfButton from "../components/csf-button";

export default {
  name: "user-profile",
  components: { CsfButton },
  props: {
    currentYear: String
  },
  data() {
    return {
      isOpen: false
    };
  },
  created() {
    this.bindRefs();
  },
  mounted() {
    this.$store.commit("centerMap", this.profile.latlng);
  },
  computed: {
    profile() {
      return this.$store.state.selectedProfile;
    },
    userId() {
      this.bindRefs();
      return this.$store.state.selectedProfileId;
    }
  },
  watch: {
    $route(to, from) {
      // update the Firebase refs to point at selected user profile
      this.bindRefs();
    }
  },
  methods: {
    bindRefs() {
      this.$store.dispatch("setSelectedProfile", {
        profileId: this.$route.params.id
      });
    },
    toggleOverlay() {
      this.isOpen = !this.isOpen;
    },
    closeButtonClicked() {
      this.$store.commit("centerMap", this.$store.state.initialMapCenter);
      this.$router.push({ name: "browse" });
    }
  }
};
</script>


// WEBPACK FOOTER //
// UserProfile.vue?4964e01f